export {DialogTitleStyle} from './DialogTitleStyle';
export {withDialogTitle} from './withDialogTitle';
export {DialogTitle as default} from './DialogTitle';
